import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Pencil, Copy, Trash2, Mail, Sparkles, Info } from "lucide-react";

const STATUS = { draft: { label: "Borrador", cls: "bg-amber-100 text-amber-700" }, ready: { label: "Listo", cls: "bg-emerald-100 text-emerald-700" } };

export default function AdminMailings() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [recipients, setRecipients] = useState(0);

  const load = () => adminApi.get("/admin/mailings").then((r) => setItems(r.data));
  useEffect(() => {
    load();
    adminApi.get("/admin/mailing-recipients").then((r) => setRecipients(r.data.count)).catch(() => {});
  }, []);

  const duplicate = async (m) => {
    await adminApi.post(`/admin/mailings/${m.id}/duplicate`);
    toast.success("Mailing duplicado");
    load();
  };
  const remove = async (m) => {
    if (!window.confirm(`¿Eliminar el mailing "${m.title || m.subject}"?`)) return;
    await adminApi.delete(`/admin/mailings/${m.id}`);
    toast.success("Mailing eliminado");
    load();
  };

  return (
    <div className="max-w-5xl" data-testid="admin-mailings">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-heading font-bold text-3xl tracking-tighter flex items-center gap-2"><Mail className="h-7 w-7 text-brand" /> Mailings</h1>
          <p className="text-sm text-muted-foreground mt-1">Boletines mensuales para tus clientes · {recipients} destinatarios con email</p>
        </div>
        <button onClick={() => nav("/admin/mailings/nuevo")} className="inline-flex items-center gap-2 bg-brand text-white rounded-sm px-4 py-2.5 text-sm font-semibold hover:bg-brand-dark" data-testid="new-mailing-btn"><Plus className="h-4 w-4" /> Nuevo mailing</button>
      </div>

      <div className="flex gap-2 items-start bg-blue-50 border border-blue-200 rounded-sm p-3 mb-5 text-sm text-blue-900">
        <Info className="h-4 w-4 mt-0.5 shrink-0" />
        <p>Redacta y guarda el boletín (manual o con IA), envíate una <strong>prueba a tu email</strong> y revísalo. Para el envío a todos los clientes, descarga la <strong>lista de destinatarios (CSV)</strong> y el <strong>HTML</strong> desde el editor y envíalo con <a href="https://resend.com/broadcasts" target="_blank" rel="noreferrer" className="underline font-medium">Resend Broadcasts</a> (gratis): sube el CSV como <em>Audience</em> y pega el HTML en un <em>Broadcast</em>.</p>
      </div>

      {items.length === 0 ? (
        <div className="border border-dashed border-border rounded-sm p-12 text-center text-muted-foreground">
          <Sparkles className="h-8 w-8 mx-auto mb-3 text-brand/50" />
          <p>Aún no hay mailings. Crea el primero manualmente o genéralo con IA.</p>
        </div>
      ) : (
        <div className="border border-border rounded-sm overflow-hidden bg-white">
          <table className="w-full text-sm">
            <thead className="bg-secondary/60 text-left text-xs text-muted-foreground">
              <tr><th className="px-4 py-2.5">Título</th><th className="px-4 py-2.5">Asunto</th><th className="px-4 py-2.5 w-24">Mes</th><th className="px-4 py-2.5 w-24">Estado</th><th className="px-4 py-2.5 w-40 text-right">Acciones</th></tr>
            </thead>
            <tbody>
              {items.map((m) => (
                <tr key={m.id} className="border-t border-border hover:bg-secondary/30" data-testid={`mailing-row-${m.id}`}>
                  <td className="px-4 py-2.5 font-medium">{m.title || "—"} {m.source === "auto" && <span className="ml-1 text-[10px] bg-brand/10 text-brand px-1.5 py-0.5 rounded-full align-middle">IA auto</span>}</td>
                  <td className="px-4 py-2.5 text-muted-foreground truncate max-w-[240px]">{m.subject}</td>
                  <td className="px-4 py-2.5 text-xs font-mono text-muted-foreground">{m.month || "—"}</td>
                  <td className="px-4 py-2.5"><span className={`text-xs px-2 py-0.5 rounded-full ${(STATUS[m.status] || STATUS.draft).cls}`}>{(STATUS[m.status] || STATUS.draft).label}</span></td>
                  <td className="px-4 py-2.5 text-right whitespace-nowrap">
                    <button onClick={() => nav(`/admin/mailings/${m.id}/editar`)} title="Editar / reutilizar" className="p-1.5 hover:text-brand" data-testid={`edit-mailing-${m.id}`}><Pencil className="h-4 w-4" /></button>
                    <button onClick={() => duplicate(m)} title="Duplicar" className="p-1.5 hover:text-brand" data-testid={`dup-mailing-${m.id}`}><Copy className="h-4 w-4" /></button>
                    <button onClick={() => remove(m)} title="Eliminar" className="p-1.5 text-red-500 hover:text-red-700" data-testid={`del-mailing-${m.id}`}><Trash2 className="h-4 w-4" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
